import { notification } from 'antd'

export forceCompliancy = (toTest) ->
  # As this silently transforms user input, don't use this in any place that:
  # - the user does not immediately get feedback about his transformed input, and get a chance to decide whether to continue
  # - automatically saves the value returned from this function
  # - (ie needs an explicit `save` button press, after seeing evidence of his input being transformed), not eg onBlur.
  toTest.replace(
    /\<|\>|\"|\{|\}|\||\^|\`|\\|\t|\n/gi, ''
  )

export testNonCompliancy = (toTest...) ->
  toTest.find((str) ->
    /\<|\>|\"|\{|\}|\||\^|\`|\\|\t|\n/gi.test(str)
  )

export nonComplianceMessage = ->
  notification.error({
    message: "Badly-formed Sparql query detected."
    description: "This Sparql query seems badly-formed, probably because of an illegal uri."
  })
